import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_3 = { class: "fw-bolder text-muted" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" # ID ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Name")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px text-end" }, "Actions", -1)
const _hoisted_7 = { class: "text-dark fw-bolder d-block fs-6" }
const _hoisted_8 = { class: "text-dark fw-bolder d-block fs-6" }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = {
  class: "btn-group btn-group-sm pb-2 pt-1",
  role: "group"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SortingArrow = _resolveComponent("SortingArrow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_3, [
          _createElementVNode("th", {
            class: "min-w-50px",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeSort('id')))
          }, [
            _hoisted_4,
            (_ctx.sortParams.sortedBy == 'id')
              ? (_openBlock(), _createBlock(_component_SortingArrow, {
                  key: 0,
                  isOrderAsc: _ctx.sortParams.isOrderAsc
                }, null, 8, ["isOrderAsc"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("th", {
            class: "min-w-100px",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeSort('name')))
          }, [
            _hoisted_5,
            (_ctx.sortParams.sortedBy == 'name')
              ? (_openBlock(), _createBlock(_component_SortingArrow, {
                  key: 0,
                  isOrderAsc: _ctx.sortParams.isOrderAsc
                }, null, 8, ["isOrderAsc"]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_6
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (entry) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: entry.id
          }, [
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(entry.id), 1)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(entry.name), 1)
            ]),
            _createElementVNode("td", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.editButtonClicked(entry)),
                  class: "btn btn-sm btn-warning",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#LanguageModal"
                }, " Edit ", 8, _hoisted_11),
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.deleteButtonClicked(entry)),
                  "data-bs-target": "#deleteModal",
                  "data-bs-toggle": "modal",
                  class: "btn btn-sm btn-danger"
                }, " Delete ", 8, _hoisted_12)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}